import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box } from '@mui/material';
import { Button, Table } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ChartDialog from './components/ChartDialog';
import { useSelector } from 'react-redux';

export default function QuestionnaireStatistics({ showHeader }) {
  const [dataSource, setDataSource] = useState([]);
  const [currentCharacter, setCurrentCharacter] = useState({
    service: [],
  });
  const [showChart, setShowChart] = useState(false);

  const serviceData = useSelector((state) => state.service.serviceData);

  useEffect(() => {
    (async () => {
      try {
        const data = (
          await axios.get('/ezcon/api/getQuestionnaireResultTable', {
            headers: {
              authorization: localStorage.getItem('feathers-jwt'),
            },
          })
        ).data;
        setDataSource(data);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  const columns = [
    {
      title: '所屬單位',
      dataIndex: 'companyName',
      width: 200,
      lock: 'left',
    },
    {
      title: '評分對象',
      dataIndex: 'ratingObject',
      width: 100,
      lock: 'left',
    },
    {
      title: '評分項目',
      dataIndex: 'service',
      cell: (service) =>
        service
          .map(
            (item) => serviceData.data.find((i) => i.id === item)?.name || ''
          )
          .join(', '),
      width: 300,
    },
    {
      title: '上個月管委會分數',
      dataIndex: 'committeeScore',
      width: 150,
      cell: (val) => `${val}/5`,
    },
    {
      title: '上個月住戶平均分數',
      dataIndex: 'residentScore',
      width: 200,
      cell: (val) => `${val}/5`,
    },
    {
      title: '上個月加權分數',
      dataIndex: 'totalScore',
      width: 150,
      cell: (val) => `${val}/5`,
    },
    {
      title: '滿意度',
      dataIndex: 'satisfaction',
      width: 100,
      cell: (val) => `${val}%`,
    },
    {
      title: '操作',
      cell: (_v, _i, character) => (
        <Button
          type="primary"
          onClick={() => {
            setCurrentCharacter(character);
            setShowChart(true);
          }}
        >
          顯示更多
        </Button>
      ),
      width: 300,
      lock: 'right',
    },
  ];

  return (
    // container
    <Box>
      {/* breadcrumb */}
      {showHeader !== false && (
        <PageHeader
          breadcrumbs={['問卷管理', '統計列表'].map((i) => ({ name: i }))}
          title="統計列表"
        />
      )}
      {/* statistics list */}
      <Box
        sx={{
          border: 'none',
          borderRadius: '3px',
          padding: '20px',
          backgroundColor: '#fff',
        }}
      >
        <Table {...{ dataSource, columns }} />
      </Box>
      {/* statistics chart */}
      <ChartDialog
        {...{ visible: showChart, setVisible: setShowChart, currentCharacter }}
      />
    </Box>
  );
}
